'use client';

import { useState } from "react";

type Tab = {
  label: string;
  content: React.ReactNode;
};

type TabsProps = {
  tabs: Tab[];
  orientation?: "horizontal" | "vertical";
  contentClass?: string;
};

export default function ToggleTabs({
  tabs,
  orientation = "horizontal",
  contentClass = "mt-6 max-w-5xl mx-auto",
}: TabsProps) {
  const [activeIndex, setActiveIndex] = useState(0);
  const isVertical = orientation === "vertical";

  return (
    <div
      className={`w-full ${
        isVertical ? "md:flex md:min-h-[400px]" : ""
      }`}
    >
      {/* Mobile: select dropdown (always visible on small screens) */}
      <div className="md:hidden mb-4">
        <select
          className="w-full p-2 border border-gray-300 rounded-md text-sm"
          value={activeIndex}
          onChange={(e) => setActiveIndex(Number(e.target.value))}
        >
          {tabs.map((tab, index) => (
            <option key={index} value={index}>
              {tab.label}
            </option>
          ))}
        </select>
      </div>

      {/* Desktop: tab buttons */}
      <div
        className={`hidden md:flex ${
          isVertical
            ? "flex-col w-64 border-r  "
            : "justify-center border-b border-gray-300"
        }`}
      >
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`px-8 py-3 text-lg font-medium transition-colors ${
              activeIndex === index
                ? isVertical
                  ? "bg-yellow-400 font-semibold"
                  : "text-black border-b-2 border-black bg-matco"
                : "text-gray-600 hover:text-black hover:bg-matco"
            } ${isVertical ? "text-left" : ""}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Section */}
      <div className={`flex-1 ${contentClass}`}>{tabs[activeIndex].content}</div>
    </div>
  );
}
